import { Base } from './_base.model';

export class WorkflowTemplate extends Base {
  id: number;
  name: string;
  deleted: boolean;
  checklists: any[];
}
